module.exports = __webpack_public_path__ + "img/ferie.8573c4a3.png";